import { Collapse, Flex, Icon, Stack, useDisclosure } from '@chakra-ui/react';
import { useGetInterviewStagesByIdQuery } from '@/store/query/interview-plan';
import { CenterSpinner } from '../loadders';
import { ActivityCard } from '@/pages/ats-job-creation/tabs/interview-plan/stage/activity';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/solid';
import { Scorecard } from '@/assets/icons/ats/empty';
import { KText } from '@/ui-library/components';
import { useIntegrations } from '@/hooks/use-integrations';

const Stage = ({ stage }) => {
  const { id, name, mandatory } = stage;
  const { isHackerRankEnabled } = useIntegrations();
  const activitiesLength = !isHackerRankEnabled
    ? stage?.ats_job_stage_actions?.filter(
        (item) => item?.kind !== 'hackerrank'
      )?.length
    : stage?.ats_job_stage_actions?.length;
  const { isOpen, onToggle } = useDisclosure();
  const activities = stage?.ats_job_stage_actions;

  return (
    <Flex
      bg={mandatory ? '#fafafa' : '#fff'}
      borderRadius="sm"
      border="1px solid"
      borderColor="border-color"
      justifyContent="center"
      flexDir="column"
      key={id}
    >
      <Flex
        minH="60px"
        alignItems="center"
        pl="xxl"
        pr="xxl"
        onClick={onToggle}
        cursor={activitiesLength > 0 ? 'pointer' : 'unset'}
      >
        <KText size="sm-medium" color="secondary-900">
          {name}
        </KText>
        <Flex ml="auto" gap="20px">
          {activitiesLength > 0 && (
            <KText
              size="sm-medium"
              p="2px 8px"
              bg="ats-tertiary"
              borderRadius="2px"
              color="secondary-700"
            >{`${activitiesLength} ${
              activitiesLength === 1 ? 'Activity' : 'Activities'
            }`}</KText>
          )}
          {activitiesLength > 0 && (
            <Icon
              width="24px"
              height="24px"
              cursor="pointer"
              ml="-12px"
              as={isOpen ? ChevronDownIcon : ChevronRightIcon}
              onClick={() => onToggle()}
            />
          )}
        </Flex>
      </Flex>
      {activitiesLength > 0 && (
        <Collapse in={isOpen} unmountOnExit={false}>
          <Flex m="lg" mt="0" gap="5px" flexDir="column">
            {activities?.map((activity) => (
              <ActivityCard
                activity={activity}
                key={activity?.id}
                stage={stage}
                disableAction={true}
                disableDrag={true}
              />
            ))}
          </Flex>
        </Collapse>
      )}
    </Flex>
  );
};

export const InterviewPlan = ({ job }) => {
  const { data, isLoading, isFetching } = useGetInterviewStagesByIdQuery(
    {
      atsJobId: job?.id,
    },
    { skip: !job?.id }
  );

  if (isLoading || isFetching) {
    return <CenterSpinner h="60vh" w="100%" />;
  }

  const stages = data || [];

  if (stages?.length === 0)
    return (
      <Flex
        h="90%"
        w="100%"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
      >
        <Icon as={Scorecard} w="150px" h="115px" />
        <KText size="sm-medium" mt="36px" mb="9px">
          LOOKS EMPTY IN HERE
        </KText>
        <KText size="lg-semi-bold">This job does not have any stages</KText>
      </Flex>
    );

  return (
    <Stack w="100%">
      {stages.map((stage) => {
        return <Stage stage={stage} key={stage?.id} />;
      })}
    </Stack>
  );
};
